import { DashboardTrackingResponseType } from "../../../types/types";
import { api } from "../api";

const findCustomerTrackingData = async (token: string) => {
    return api.get<DashboardTrackingResponseType>("/dashboard/customer/tracking", {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default findCustomerTrackingData;
